const keeps = {
    state: {
        routesName: "",
    },

    mutations: {
        SET_NAME: (state, msg) => {
            state.routesName = msg;
        },
    },
};

export default keeps;